import { COLORS } from '../../../../../utils/colors';

export const useBlockedTimeStyles = () => {
  return {
    topBar: {
      display: 'block',
      width: '100%',
      height: '1px',
      margin: '1.5rem',
      marginLeft: '0rem',
      backgroundColor: `${COLORS.MEDIUM_GRAY}`,
    },
    saveButton: {
      position: 'absolute',
      right: '2rem',
      top: '1.5rem',
      paddingLeft: '2rem',
      paddingRight: '2rem',
      backgroundColor: COLORS.MEDIUM_GRAY,
      borderRadius: '2rem',
      color: '#fff !important',
      height: '2rem',
      '&: hover': {
        backgroundColor: COLORS.MEDIUM_GRAY,
      },
    },
    addTimeBlockButton: {
      borderRadius: '2rem',
      margin: '.5rem 0',
      height: '2.75rem',
      color: COLORS.MEDIUM_GRAY,
      border: `1px solid ${COLORS.MEDIUM_GRAY}`,
      '&:Hover': {
        border: `1px solid ${COLORS.MEDIUM_GRAY}`,
      },
    },
    tableStyles: {
      borderSpacing: 0,
      textAlign: 'center',
      overflow: 'auto',
      tableLayout: 'fixed',
      width: '100%',
      borderCollapse: 'collapse',
    },
    tableRowStyles: {
      lineHeight: '1.5rem',
      position: 'relative',
      overflow: 'hidden',
    },
    firstCell: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    icon: {
      marginRight: '0.5rem',
      cursor: 'pointer',
      color: '#888',
    },
  };
};
